import { fetchCategoryList } from './flows/fetch-category-list';
import { LoadingState, LoadingStates, PoiCategory } from '../poi';
import { types } from 'mobx-state-tree';

export const CategoryStore = types
  .model({
    list: types.optional(types.array(PoiCategory), []),
    status: types.optional(LoadingState, LoadingStates.init),
  })
  .actions((self) => ({
    fetch: (...args) => fetchCategoryList(self, ...args),

    allSelected: () =>
      self.list.length === self.list.filter((item) => item.selected).length,

    getSelected: () => self.list.filter((category) => category.selected),

    selectAll: () => {
      self.list.map((item) => (item.selected = true));
    },
    deselectAll: () => {
      self.list.map((item) => (item.selected = false));
    },
  }));

export const initialState = {
  list: [
    { _id: '1', name: 'sight', color: '#FFEB00', selected: true },
    { _id: '2', name: 'eatdrink', color: '#FF7400', selected: true },
    { _id: '3', name: 'shopping', color: '#FF76CE', selected: true },
    { _id: '4', name: 'place', color: '#89CA13', selected: true },
    { _id: '5', name: 'emergency', color: '#FC454E', selected: false },
    { _id: '6', name: 'recreation', color: '#C00CAA', selected: true },
    {
      _id: '7',
      name: 'placeofworship',
      color: '#D4B083',
      selected: true,
    },
  ],
};
